export const environment = {
  production: false,
  environment: 'development',
  apiUrl: 'https://api.dev.globalfeedlca.com/api',
  enableTemplate: true,
  enableDebug: true,
  logLevel: 'debug'
};
